import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 bg-[#151210] text-center border-t border-[#d4a574]/5" data-id="element-35">
      <p className="text-[#a8a29e]/40 text-sm mb-2" data-id="element-36">
        © 2026 Protocolo 3R · Todos los derechos reservados
      </p>
      <p className="text-[#a8a29e]/30 text-xs max-w-md mx-auto" data-id="element-37">
        Este programa no sustituye atención psicológica profesional. Si sientes
        que no puedes más, por favor busca ayuda especializada.
      </p>
    </footer>;
}